class BlocksPagePagination {
  constructor() {
    this.blocksPerPage = 9;
    this.currentPage = 1;
    this.totalBlocks = 0;
    this.totalPages = 0;
    this.blocksContainer = null;
    this.paginationContainer = null;
    this.activeFilter = null; // Pour stocker le tag actif
    this.allBlocks = []; // Pour stocker tous les blocks
    this.filteredBlocks = []; // Pour stocker les blocks filtrés
    
    this.init();
  }

  init() {
    // Attendre que le DOM soit chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupPagination());
    } else {
      this.setupPagination();
    }
  }

  setupPagination() {
    this.blocksContainer = document.querySelector('.blocks-page__blocks-container');
    if (!this.blocksContainer) return;

    // Stocker tous les blocks
    this.allBlocks = Array.from(this.blocksContainer.querySelectorAll('.blocks-page__block'));
    this.filteredBlocks = [...this.allBlocks];
    this.totalBlocks = this.allBlocks.length;
    this.totalPages = Math.ceil(this.totalBlocks / this.blocksPerPage);

    // Ajouter les event listeners pour les tags
    this.setupTagFilters();

    // Si on a moins de 4 blocks, pas besoin de pagination
    if (this.totalBlocks <= this.blocksPerPage) {
      return;
    }

    // Créer le conteneur de pagination
    this.createPaginationContainer();
    
    // Masquer tous les blocks sauf les 3 premiers
    this.showPage(1);
    
    // Générer la pagination
    this.generatePagination();
  }

  setupTagFilters() {
    const tagElements = document.querySelectorAll('.blocks-page__tag');
    
    tagElements.forEach(tagElement => {
      tagElement.addEventListener('click', (e) => {
        const tag = e.target.textContent.trim();
        this.filterByTag(tag);
      });
    });
  }

  filterByTag(tag) {
    // Mettre à jour le filtre actif
    this.activeFilter = tag;
    
    // Mettre à jour l'état actif des tags
    this.updateActiveTag(tag);
    
    // Filtrer les blocks
    if (tag === 'Tous' || tag === 'All') {
      this.filteredBlocks = [...this.allBlocks];
    } else {
      this.filteredBlocks = this.allBlocks.filter(block => {
        const blockTags = block.getAttribute('data-tag');
        if (!blockTags) return false;
        
        const tags = blockTags.split(',').map(t => t.trim());
        return tags.includes(tag);
      });
    }

    // Mettre à jour les compteurs
    this.totalBlocks = this.filteredBlocks.length;
    this.totalPages = Math.ceil(this.totalBlocks / this.blocksPerPage);

    // Réinitialiser à la première page
    this.currentPage = 1;

    // Masquer tous les blocks d'abord
    this.allBlocks.forEach(block => {
      block.style.display = 'none';
      block.style.opacity = '0';
    });

    // Afficher la première page des blocks filtrés
    this.showPage(1);
    
    // Régénérer la pagination
    this.generatePagination();
  }

  updateActiveTag(activeTag) {
    const tagElements = document.querySelectorAll('.blocks-page__tag');
    
    tagElements.forEach(tagElement => {
      if (tagElement.textContent.trim() === activeTag) {
        tagElement.classList.add('blocks-page__tag--active');
      } else {
        tagElement.classList.remove('blocks-page__tag--active');
      }
    });
  }

  createPaginationContainer() {
    // Créer le conteneur de pagination après le conteneur des blocks
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.className = 'blocks-page__pagination font-helvetica-neue';
    this.blocksContainer.parentNode.insertBefore(this.paginationContainer, this.blocksContainer.nextSibling);
  }

  showPage(pageNumber) {
    const startIndex = (pageNumber - 1) * this.blocksPerPage;
    const endIndex = startIndex + this.blocksPerPage;

    // Masquer tous les blocks d'abord
    this.allBlocks.forEach(block => {
      block.style.display = 'none';
      block.style.opacity = '0';
    });

    // Afficher seulement les blocks filtrés pour cette page
    this.filteredBlocks.forEach((block, index) => {
      if (index >= startIndex && index < endIndex) {
        block.style.display = 'flex';
        block.style.opacity = '0';
        // Animation d'apparition
        setTimeout(() => {
          block.style.opacity = '1';
        }, 50 * (index - startIndex));
      }
    });

    this.currentPage = pageNumber;

    // Scroll smooth vers le haut de la page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  generatePagination() {
    this.paginationContainer.innerHTML = '';

    // Si pas de blocks filtrés, ne pas afficher la pagination
    if (this.filteredBlocks.length === 0) {
      return;
    }

    // Si moins de blocks que la limite par page, ne pas afficher la pagination
    if (this.filteredBlocks.length <= this.blocksPerPage) {
      return;
    }

    // Bouton précédent
    const prevButton = document.createElement('button');
    prevButton.className = 'blocks-page__pagination-btn blocks-page__pagination-prev';
    prevButton.innerHTML = '<span>\
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M9.66406 2.66675L4.33073 8.00008L9.66406 13.3334" stroke="black" stroke-width="1.5" stroke-linecap="square"/>\
    </svg>\
    </span>'; 
    prevButton.disabled = this.currentPage === 1;
    prevButton.addEventListener('click', () => {
      if (this.currentPage > 1) {
        this.showPage(this.currentPage - 1);
        this.generatePagination();
      }
    });
    this.paginationContainer.appendChild(prevButton);

    // Numéros de pages
    const maxVisiblePages = 3;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    // Ajuster si on est près de la fin
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Première page si pas visible
    if (startPage > 1) {
      const firstPageBtn = document.createElement('button');
      firstPageBtn.className = 'blocks-page__pagination-btn';
      firstPageBtn.textContent = '1';
      firstPageBtn.addEventListener('click', () => {
        this.showPage(1);
        this.generatePagination();
      });
      this.paginationContainer.appendChild(firstPageBtn);

      if (startPage > 2) {
        const dots = document.createElement('span');
        dots.className = 'blocks-page__pagination-dots';
        dots.textContent = '...';
        this.paginationContainer.appendChild(dots);
      }
    }

    // Pages visibles
    for (let i = startPage; i <= endPage; i++) {
      const pageBtn = document.createElement('button');
      pageBtn.className = `blocks-page__pagination-btn ${i === this.currentPage ? 'blocks-page__pagination-active' : ''}`;
      pageBtn.textContent = i;
      pageBtn.addEventListener('click', () => {
        this.showPage(i);
        this.generatePagination();
      });
      this.paginationContainer.appendChild(pageBtn);
    }

    // Dernière page si pas visible
    if (endPage < this.totalPages) {
      if (endPage < this.totalPages - 1) {
        const dots = document.createElement('span');
        dots.className = 'blocks-page__pagination-dots';
        dots.textContent = '...';
        this.paginationContainer.appendChild(dots);
      }

      const lastPageBtn = document.createElement('button');
      lastPageBtn.className = 'blocks-page__pagination-btn';
      lastPageBtn.textContent = this.totalPages;
      lastPageBtn.addEventListener('click', () => {
        this.showPage(this.totalPages);
        this.generatePagination();
      });
      this.paginationContainer.appendChild(lastPageBtn);
    }

    // Bouton suivant
    const nextButton = document.createElement('button');
    nextButton.className = 'blocks-page__pagination-btn blocks-page__pagination-next';
    nextButton.innerHTML = '<span>\
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M6.33203 2.66675L11.6654 8.00008L6.33203 13.3334" stroke="black" stroke-width="1.5" stroke-linecap="square"/>\
    </svg>\
    </span>';
    nextButton.disabled = this.currentPage === this.totalPages;
    nextButton.addEventListener('click', () => {
      if (this.currentPage < this.totalPages) {
        this.showPage(this.currentPage + 1);
        this.generatePagination();
      }
    });
    this.paginationContainer.appendChild(nextButton);
  }
}

// Initialiser la pagination
new BlocksPagePagination();
